/**
 * @description 将页面元素转成图片
 * @author wansongtao
 * @date 2021-07-27
 */

import html2canvas from 'html2canvas';

/**
 * @description 获取参数数据类型
 * @param {*} obj
 * @returns {string} 返回数据类型字符串
 */
const getDataType = (obj) => {
  let res = Object.prototype.toString.call(obj).split(' ')[1];
  res = res.substring(0, res.length - 1).toLowerCase();
  return res;
};

/**
 * @description 页面元素转图片
 * @param {object} ele dom节点
 * @returns {promise} 成功 resolve(url) 失败 reject()
 */
const domToImage = ele => new Promise((resolve, reject) => {
  if (getDataType(ele).indexOf('html') === -1) {
    reject();
    return;
  }

  html2canvas(ele, {
    backgroundColor: '#fff', // 背景颜色
    dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
    scale: 2, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
    useCORS: true,
  }).then((canvas) => {
    const imgurl = canvas.toDataURL('image/png');

    if (imgurl.indexOf('image/png') !== -1) {
      resolve(imgurl);
    }
    reject();
  });
});

export default domToImage;
